import { render, staticRenderFns } from "./WebhookConfigForm.vue?vue&type=template&id=8f05d57e"
import script from "./WebhookConfigForm.vue?vue&type=script&lang=js"
export * from "./WebhookConfigForm.vue?vue&type=script&lang=js"
import style0 from "./WebhookConfigForm.vue?vue&type=style&index=0&id=8f05d57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports